import { Component } from '@angular/core';
import { AgentService } from '../../services/agent.service';
import { OperatorService } from 'src/app/services/operator.service';
import { IAgent } from '../../interfaces/agent';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-teller',
  templateUrl: './teller.component.html',
  styleUrls: ['./teller.component.scss'],
})
export class TellerComponent {
  agents!: IAgent[];
  visible: boolean = false;
  value: string = '';
  labelString: String = '';

  name: any;
  group: any;
  usercode: any;
  password: any;

  grourpname: any;
  selectednames: any;

  operator: any = [{ value: 'JM' },{ value: 'JACK' },{ value: 'TEST' }];
  selectedoperator: any;

  version: any = [
    { value: 'v8.14' },
    { value: 'v8.11' },
    { value: 'v8.12' },
    { value: 'v8.17' },
  ];
  selectednversion: any;

  qrposition: any = [{ value: 'Left' }, { value: 'Right' }];
  selectedqrposition: any;

  constructor(
    private agentServ: AgentService,
    private operatiorServ: OperatorService
  ) {}

  ngOnInit() {
    this.loadAllNames();
    this.loadAgents();
  }

  generateRandomNumbers() {
    let randomNumbers = '';
    for (let i = 0; i < 5; i++) {
      const randomNumber = Math.floor(Math.random() * 10); // Generates a random number between 0 and 9
      randomNumbers += randomNumber.toString();
    }
    return randomNumbers;
  }

  loadAgents() {
    this.agentServ.getData().subscribe((res) => {
      // console.log(res);
      this.agents = res;
    });
  }
  ResetPassword() {
    this.password = this.generateRandomNumbers();
  }

  loadAllNames() {
    this.operatiorServ.getAllNames().subscribe((res) => {
      // console.log(res);
      this.grourpname = res.map((data: any) => {
        return {
          name: data.name,
        };
      });
    });
  }

  onClickAdd() {
    this.labelString = 'ADD';
    this.clearText();
    this.visible = true;
    this.password = this.generateRandomNumbers();
  }

  LoadAllNames() {}

  clearText() {
    this.name = null;
    this.usercode = null;
    this.selectednversion = null;
    this.selectedoperator = null;
    this.selectednames = null;
    this.selectedqrposition = null;
  }

  AddUpdate() {
    if (this.labelString == 'ADD') {
      this.Add();
    } else if (this.labelString == 'SAVE') {
      this.Update();
    }
  }
  Delete(usercode: any) {
    this.agentServ.Delete({ usercode: usercode }).subscribe((res: any) => {
      if (res.flag == 1) {
        this.loadAgents();
        Swal.fire({
          icon: 'success',
          title: 'SUCCESS',
          text: 'Teller Successfully Deleted!',
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'NOTICE',
          text: res.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }
  Update() {
    if (this.Validation()) {
      let data = {
        name: this.name,
        group: this.selectednames,
        usercode: this.usercode,
        password: this.password,
        operator: this.selectedoperator,
        version: this.selectednversion,
        qrposition: this.selectedqrposition,
      };
      this.agentServ.Update(data).subscribe((res: any) => {
        if (res.flag == 1) {
          this.loadAgents();
          Swal.fire({
            icon: 'success',
            title: 'SUCCESS',
            text: 'Teller Successfully Updated!',
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'NOTICE',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    }
  }

  Add() {
    if (this.Validation()) {
      let data = {
        name: this.name,
        group: this.selectednames,
        usercode: this.usercode,
        password: this.password,
        operator: this.selectedoperator,
        version: this.selectednversion,
        qrposition: this.selectedqrposition,
      };
      this.agentServ.Add(data).subscribe((res: any) => {
        if (res.flag == 1) {
          this.loadAgents();
          Swal.fire({
            icon: 'success',
            title: 'SUCCESS',
            text: 'Teller Successfully Added!',
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'NOTICE',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });

      this.password = this.generateRandomNumbers();
      this.clearText();
    } else {
    }
  }

  EditInfo(row: any) {
    this.labelString = 'SAVE';
    console.log(row);
    this.visible = true;
    this.name = row.name;
    this.selectedoperator = row.operator;
    this.selectednames = row.group;
    this.selectednversion = row.version;
    this.usercode = row.usercode;
    this.password = row.password;
    this.selectedqrposition = row.qrposition;
  }
  Validation() {
    if (
      this.name == null ||
      this.selectedoperator == null ||
      // this.selectednames == null ||
      // this.selectednversion == null ||
      this.usercode == null ||
      this.password == null
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'NOTICE',
        text: 'Input all fields!',
        showConfirmButton: false,
        timer: 1500,
      });
      return false;
    } else {
      // if (this.usercode.length != 9) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'NOTICE',
      //     text: 'Check Usercode!',
      //     showConfirmButton: false,
      //     timer: 1500,
      //   });
      //   return false;
      // } else {
      return true;
      // }
    }
  }
}
